module.exports = __webpack_public_path__ + "static/column-8a75328a4d0fd6519dfdbacbe9675f01.jpg";